jQuery(document).ready(
  function()
  {
    // on réinitialise le formulaire
    jQuery('select#wish option#none').prop('selected', true);
  }
);


/*
 * Ajax : récupère la jauge pour le type d'espace choisi
 * active les autes éléments du formulaire
 */
function get_space_jauge(selectSpace){

  // initialisation des variables
  var space    = '';
  var formData = new FormData();

  // récupération de la valeur du select
  space = selectSpace.value;
  // pas d'espace recherché --> verrouillage du formulaire
  if(space == 'none')
  {
    // on réinitialise le formulaire
    jQuery('select#participants').html('<option>Nombre de participants</option>');
    jQuery('select#participants').attr('disabled', 'disabled');
    jQuery('select#participants').removeAttr('onchange');
    jQuery('input#view-results').attr('disabled', 'disabled');
  }
  // callback ajax pour aller chercher les jauges correspondantes
  else
  {
    // récupération du type d'espace recherché
    formData.append('entity_space', space);
    formData.append('get_label', 0);
    // ajax
    jQuery.ajax({
      type: "POST",
      url: '/ajax/search_space_jauge',
      data: formData,
      async: true,
      processData: false,
      contentType: false
    })
    .done(function(result){
      if(result.options && result.space)
      {
        var research          = result.space;
        var onchange          = "add_formaction(this, '" + research + "')";
        var formaction_search = '/recherche/' + research;

        // on implemente les resultats
        jQuery('select#participants').html(result.options);
        // on ouvre la possibilité de modifier le formulaire et de le poster
        jQuery('select#participants').removeAttr('disabled');
        jQuery('input#view-results').removeAttr('disabled');
        // on ajoute un callback js modifier les formaction des submits
        jQuery('select#participants').attr('onchange', onchange );
        // on ajoute un attribut formaction sur les submit
        jQuery('input#view-results').removeAttr('formaction');
        jQuery('input#view-results').attr('formaction', formaction_search );
      }
    })
    .fail(function(){
      console.log('fail');
    });
  }
  // fin if(space == 'none')
}


/*
 * ajoute un attribut formaction au submit pour rediriger vers la page souhaitée
 */
function add_formaction(spaceJauge, space)
{
  // récupération de la valeur du select jauge
  var jauge = '';
  jauge     = spaceJauge.value;

  // gestion du formaction
  // vue recherche d'espace + filtre contextuel sur la jauge
  // page de jauge precisé -> pas de filtre contextuel
  var formaction_search = '/recherche/' + space;
  // prise en compte de la jauge demandée
  if(jauge != 'none')
  {
    //formaction_search = formaction_search + '/' + jauge;
    formaction_search = formaction_search + '?field_nombre_de_per_target_id=' + jauge;
  }
  // on ajoute un attribut formaction sur les submit
  jQuery('input#view-results').removeAttr('formaction');
  jQuery('input#view-results').attr('formaction', formaction_search );
}
